export default {
  groupName: 'ford-eu',
  appName: 'Ford Europe',
  isAuto: true,
  image: 'ford.png',
  baseRoute: '/ford-eu',
  description:
  "Ford - Europe Advertising Dashboard"
}



// WEBPACK FOOTER //
// ./src/app/configuration/FordEU/config/main.js